/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type DataRequestReceiver = typeof DataRequestReceiver[keyof typeof DataRequestReceiver];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataRequestReceiver = {
  AllGridOperators: 'AllGridOperators',
  Coteq: 'Coteq',
  Enexis: 'Enexis',
  Liander: 'Liander',
  Rendo: 'Rendo',
  Stedin: 'Stedin',
  WestlandInfra: 'WestlandInfra',
} as const;
